export const home = [
    {
        path: "/",
        name: "Home",
        isMenu: true,
        component: () =>
            import("@/views/home/Home.vue"),
    },
];